// Ant Design and React imports
import React, { useState } from 'react';
import {
  Layout,
  Menu,
  Dropdown,
  Button,
  Image,
  Divider,
  Avatar,
  Flex,
  MenuProps,
  Typography,
  Grid,
} from 'antd';
import {
  QuestionCircleOutlined,
  MenuOutlined,
  UserOutlined,
  DownOutlined,
} from '@ant-design/icons';
import { useAuth } from 'react-oidc-context';
import { useDispatch } from 'react-redux';

// App imports
import Logo from '../../assets/logo.png';
import { parseRoles } from 'src/utils/helpers';
import { actions } from 'src/redux/features/session/slice';
import en from 'src/messages/en.json';
const { useBreakpoint } = Grid;
const { Header } = Layout;

const NavBar = () => {
  const auth = useAuth();
  const screens = useBreakpoint();
  const dispatch = useDispatch();

  const [roles] = useState<string[]>(
    parseRoles(auth?.user?.profile?.role as string),
  );

  const toggleMenu = () => {
    dispatch(actions.setOffCanvasMenu());
  };

  const onLogout = async () => {
    await auth.signoutRedirect({
      post_logout_redirect_uri: `${window.location.origin}/logout`,
    });
  };

  const loginUserName = auth.user.profile.name
    .split('@')[0]
    .split('.')
    .slice(0, 2)
    .reverse()
    .join(', ')
    .replace(/\b\w/g, (char) => char.toUpperCase());

  const items: MenuProps['items'] = [
    {
      label: en.Common.Label.logOut,
      key: 'logout',
      onClick: onLogout,
    },
  ];

  return (
    <Header
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 1rem',
        height: '56px',
      }}
    >
      <Flex align="center" gap={'small'}>
        {screens.lg ? (
          ''
        ) : (
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={toggleMenu}
            style={{ color: 'white' }}
          />
        )}
        <Image src={Logo} preview={false} height={26} alt="Logo" />
      </Flex>

      <Flex align="center">
        <Button
          type="text"
          icon={<QuestionCircleOutlined style={{ fontSize: '1.1rem' }} />}
          onClick={() =>
            window.open(process.env.REACT_APP_HELP_DOC_URL, '_blank')
          }
          style={{ color: 'white' }}
        />
        <Divider
          type="vertical"
          style={{ backgroundColor: 'white', height: '30px' }}
        ></Divider>
        <Flex
          gap={'large'}
          align="center"
          style={{ color: 'white', padding: '0 10px' }}
        >
          <Avatar
            size={'large'}
            style={{
              fontSize: '16px',
              backgroundColor: 'white',
              color: '#6C6C6C',
              fontWeight: 'bold',
            }}
          >
            {loginUserName
              .split(' ')
              .map((name) => name.charAt(0))
              .join('')
              .toUpperCase()}
          </Avatar>
          <Dropdown
            menu={{ items }}
            trigger={['click']}
            placement="bottomRight"
          >
            <Flex gap={'large'} align="center" style={{ cursor: 'pointer' }}>
              <Typography.Text
                style={{ fontWeight: 'bold', color: 'white', fontSize: '16px' }}
              >
                {loginUserName}
              </Typography.Text>
              <DownOutlined />
            </Flex>
          </Dropdown>
        </Flex>
      </Flex>
    </Header>
  );
};

export default NavBar;
